/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import style from '../styles/mediaSourceSelector.css';

const MediaSourceSelector = ({
  sources,
  className,
  propsStyle,
  typeOfSource,
  includeScreen,
  selectedSource = '',
  onSourceSelect
}) => {
  const selectClassName = className || style.sourceSelect;
  let options = [];

  propsStyle = propsStyle || {};

  const renderVideoSourcesOptions = () => {
    const videoSourcesElem = [];

    videoSourcesElem.push(
      <option value="disabled" key="disabled" disabled>Select your camera</option>
    );
    videoSourcesElem.push(
      <option value="no-source" key="no-source">No Video</option>
    );

    if (includeScreen) {
      videoSourcesElem.push(
        <option key="screen" value="screen">Screen</option>
      );
    }

    return videoSourcesElem;
  };

  const getDefaultVideoOptions = () => {
    const options = ['disabled', 'no-source'];

    if (includeScreen) {
      options.push('screen');
    }

    return options;
  };

  const renderAudioSourcesOptions = () => {
    const audioSourcesElem = [];

    audioSourcesElem.push(
      <option value="disabled" key="disabled" disabled>Select your microphone</option>
    );
    audioSourcesElem.push(
      <option value="no-source" key="no-source">No Audio</option>
    );

    return audioSourcesElem;
  };

  const getDefaultAudioOptions = () => {
    const options = ['disabled', 'no-source'];

    return options;
  };

  const renderSourcesOptions = () => {
    let sourcesArray = [];

    if (typeOfSource === 'audio') {
      sourcesArray = sourcesArray.concat(renderAudioSourcesOptions());
    } else if (typeOfSource === 'video') {
      sourcesArray = sourcesArray.concat(renderVideoSourcesOptions());
    }

    let anonymousDeviceCount = 0;

    sources.forEach((source) => {
      if (!source.label && source.id !== 'default') {
        anonymousDeviceCount++;
      }

      sourcesArray.push(
        <option key={source.id} value={source.id}>
          {source.label || (source.id === 'default' ? 'default' : `${typeOfSource === 'audio' ? 'Audio' : 'Video'} Device ${anonymousDeviceCount}`)}
        </option>
      );
    });

    return sourcesArray;
  };

  const sourceSelect = (e) => {
    onSourceSelect(e.target.value);
  };

  if (selectedSource === 'none') {
    selectedSource = 'no-source';
  }

  if (typeOfSource === 'video') {
    options = sources.map(source => source.id).concat(getDefaultVideoOptions());
  } else {
    options = sources.map(source => source.id).concat(getDefaultAudioOptions());
  }

  if (selectedSource && !options.find((id) => id && id.toLowerCase() === selectedSource.toLowerCase())) {
    selectedSource = 'disabled';
  }

  return (
    <select
      style={propsStyle}
      onChange={sourceSelect}
      className={selectClassName}
      value={selectedSource || 'disabled'}>
      {renderSourcesOptions()}
    </select>
  );
};

MediaSourceSelector.propTypes = {
  className: PropTypes.string,
  propsStyle: PropTypes.object,
  sources: PropTypes.array.isRequired,
  typeOfSource: PropTypes.string.isRequired,
  selectedSource: PropTypes.string.isRequired,
  includeScreen: PropTypes.bool.isRequired,
  onSourceSelect: PropTypes.func.isRequired
};

export default MediaSourceSelector;